(function() { module.exports = window["Bernie_l10nBundle_hr_HR"]; }());